<template>
  <div class="home" role="presentation">
    <div class="logo" role="presentation">
      <img src="@/assets/logo.png" alt="">
    </div>
    <main class="cfr" aria-label="Main content">
      <div class="nav" role="presentation">
        <h1>{{ $t("message.notFound") }}</h1>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
